import { Box, Typography } from "@mui/material";
import { ReactNode } from "react";

interface StatDisplayProps {
  icon: ReactNode;
  label: string;
  value: string | number;
}

const StatDisplay = ({ icon, label, value }: StatDisplayProps) => {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-start",
        gap: 1.5,
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
        {icon}
      </Box>
      {/* <Typography
        fontSize="14px"
        color="#ffffff"
        fontWeight="500"
        sx={{ lineHeight: 1 }}
      >
        {label}:
      </Typography> */}
      <Typography
        fontSize="14px"
        color="#ffffff"
        fontWeight="700"
        sx={{ lineHeight: 1 }}
      >
        {value}
      </Typography>
    </Box>
  );
};

export default StatDisplay;
